import { media } from 'src/views/theme';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 2rem calc((100% - var(--container-width) - 1rem) / 2) 11.1rem ;

  overflow: hidden;

  ${ media.sm } {
    padding-top: 5rem;
  }
`;

export const Flex = styled.section`
  padding-top: 2rem;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  width: 100%;

  & > *:nth-child(1) {
    // (full width - 2 gutters) * 2 / 3
    width: calc((100% - 3rem) * 2 / 3);
    flex-shrink: 0;
    flex-grow: 0;
  }
  & > *:nth-child(2) {
    flex-shrink: 0;
    width: calc((100% - 3rem) * 1 / 3);
    flex-grow: 0;
  }

  ${ media.sm } {
    flex-direction: column;
    padding-top: 0;

    & > *:nth-child(1) {
      width: auto;
    }
    
    & > *:nth-child(2) {
      width: auto;
    }
  }
`;

export const LargeDesktopOnly = styled.div`
  display: block;

  ${ media.md } {
    display: none;
  }
`;
